import { FormControl } from "@material-ui/core";
import Checkbox from "@saleor/components/Checkbox";
import MyTypography from "@saleor/components/MyTypography";
import { GetBusinessUnitQuery } from "@saleor/graphql";
import useBulkActions from "@saleor/hooks/useBulkActions";
import { makeStyles } from "@saleor/macaw-ui";
import { renderCollection } from "@saleor/misc";
import { RelayToFlat } from "@saleor/types";
import { mapBuToCompany } from "@saleor/utils/maps";
import React, { useEffect } from "react";
import { useIntl } from "react-intl";

const useStyle = makeStyles(
  theme => ({
    wrapper: {
      width: "100%",
      boxShadow: "0px 4px 16px rgb(0 0 0 / 12%)",
      padding: "1.6rem",
      background: "white",
      borderRadius: "6px"
    },
    title: {
      marginBottom: "1.8rem",
      marginTop: "3rem"
    },
    subtitle: {
      marginTop: 8
    },
    itemWrapper: {
      display: "flex",
      alignItems: "center"
    },
    root: {
      display: "flex",
      alignItems: "center"
    },
    contentItem: {
      color: theme.palette.grey[900],
      "& .MuiCheckbox-root": {
        marginLeft: "0"
      }
    }
  }),
  { name: "SoldToFilter" }
);

interface ISoldToFilterCustomerProps {
  businessUnits: RelayToFlat<GetBusinessUnitQuery["businessUnits"]>;
  onFilterByCompanyIds: (ids: string[]) => void;
}

const SoldToFilterCustomer: React.FC<ISoldToFilterCustomerProps> = ({
  businessUnits,
  onFilterByCompanyIds
}) => {
  const classes = useStyle();
  const intl = useIntl();

  const { remove: removeBu, add: addBu } = useBulkActions(
    businessUnits.map(item => item.id)
  );

  const {
    isSelected: isSelectedCompany,
    toggle: toggleCompany,
    listElements: listCompany
  } = useBulkActions(mapBuToCompany(businessUnits));

  useEffect(() => {
    onFilterByCompanyIds(listCompany);
  }, [listCompany]);

  const handleCompanyChange = (checked: boolean, id: string) => {
    toggleCompany(id);
    const currentBu = businessUnits.find(bu =>
      bu.companies.map(item => item.id).includes(id)
    );
    const currentBuCompanyIds = currentBu.companies.map(company => company.id);
    if (checked) {
      const newBuListCompany = [...listCompany]
        .filter(companyId => currentBuCompanyIds.includes(companyId))
        .concat([id]);
      if (newBuListCompany.length === currentBuCompanyIds.length) {
        addBu(currentBu.id);
      }
    } else {
      removeBu(currentBu.id);
    }
  };

  return (
    <>
      <form>
        <MyTypography variant="h7" className={classes.title}>
          ตัวกรองรายการ
        </MyTypography>
        <FormControl className={classes.wrapper}>
          <>
            <MyTypography
              variant="subtitle3"
              style={{ marginBottom: "1.25rem" }}
            >
              {intl.formatMessage({
                defaultMessage: "เลือกจากโครงการ (Contract)"
              })}
            </MyTypography>
            <div>
              <MyTypography variant="body3">Company</MyTypography>
              {renderCollection(businessUnits, item => (
                <div key={item.id}>
                  <div className={classes.contentItem}>
                    {renderCollection(item.companies, company => (
                      <div key={company?.id}>
                        <Checkbox
                          checked={isSelectedCompany(company?.id)}
                          onChange={e =>
                            handleCompanyChange(
                              e.currentTarget.checked,
                              company?.id
                            )
                          }
                        />
                        <span>{company?.shortName}</span>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </>
        </FormControl>
      </form>
    </>
  );
};
SoldToFilterCustomer.displayName = "SoldToFilterCustomer";
export default SoldToFilterCustomer;
